import React from 'react';
import { ui } from '../../styles/shared';

// Stilar från den gemensamma stilfilen
const card = ui.card;
const btn = ui.btn;

interface Props {
    isOn: boolean;
    onControl: (state: 'ON' | 'OFF') => void;
    readOnly?: boolean;
}

const SwitchControl: React.FC<Props> = ({ isOn, onControl, readOnly }) => (
    <div style={card}>
        <h3 style={{ marginTop: 0 }}>🔌 Styr strömbrytare</h3>
        <div style={{ marginBottom: '20px' }}>
            <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>
                Ström: {isOn ? '🟢 PÅ' : '🔴 AV'}
            </label>
            {!readOnly && (
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button onClick={() => onControl('ON')}
                        style={{ ...btn(isOn ? '#28a745' : '#6c757d'), padding: '12px 24px' }}>Slå på</button>
                    <button onClick={() => onControl('OFF')}
                        style={{ ...btn(!isOn ? '#dc3545' : '#6c757d'), padding: '12px 24px' }}>Slå av</button>
                </div>
            )}
        </div>
    </div>
);

export default SwitchControl;
